<template>
  <v-app>
    <error-dialog />
    <v-toolbar
      v-if="$route.path !== '/'"
      :class="['pb-1 toolbar', !isOnline && 'red lighten-5']"
      flat
      height="40px"
    >
      <v-flex class="toolbar__content">
        <v-btn
          v-if="!$route.path.includes('search') && isOnline"
          icon
          class="mx-0"
          @click="unlock"
        >
          <v-icon color="primary">arrow_back_ios</v-icon>
        </v-btn>
      </v-flex>
      <v-spacer/>
      <v-toolbar-title
        v-if="isUserDefined()"
        class="caption"
      >
        <template v-if="!isMobile">
          <span class="grey--text">[{{ user.id }}]</span>
          {{ (user.name || '').replace(/[+]/g, ' ') }}
        </template>
      </v-toolbar-title>
      <InspectionBtn v-if="displayInspectionBtn"/>
      <InspectionLoading />
      <v-btn
        v-if="isUserDefined() && isOnline"
        :loading="loading"
        color="primary"
        outline
        small
        @click="logout"
      >
        ログアウト
      </v-btn>
    </v-toolbar>
    <v-content :class="isOnline ? 'white' : 'white lighten-5'">
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import UserAuth from 'cp-ui/src/userAuth';
import ErrorDialog from 'cp-ui/src/elements/ErrorDialog';
import { GET_USER_DATA } from './queries';
import InspectionBtn from './components/InspectionBtn';
import InspectionLoading from './components/InspectionLoading';

export default {
  name: 'App',
  components: {
    ErrorDialog,
    InspectionBtn,
    InspectionLoading,
  },
  metaInfo: {
    title: 'ログインページ',
    titleTemplate: '%s | 楽天Car検査',
    htmlAttrs: {
      lang: 'ja',
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ],
  },
  apollo: {
    user: {
      query: GET_USER_DATA,
      result(data) {
        this.$store.commit('setUserData', data);
      },
    },
  },
  data() {
    return {
      loading: false,
      user: null,
      userAuth: new UserAuth({ apollo: this.$apollo }),
    };
  },
  computed: {
    error() {
      return this.$store.state.error;
    },
    appointmentId() {
      return this.$route.params.id || 0;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    displayInspectionBtn() {
      return this.appointmentId && this.isMobile;
    },
  },
  methods: {
    logout() {
      const next = () => {
        if (process.browser && window) {
          if (window.localStorage) window.localStorage.clear();
          if (window.sessionStorage) window.sessionStorage.clear();
        }
        this.$store.commit('setUser');
        this.$router.push('/');
      };

      this.userAuth.userLogout({ onFailure: next, onSuccess: next });
    },
    unlock() {
      this.$router.push('/search');
    },
    isUserDefined() {
      return !!(this.user && this.user.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue